import script from "./base-select-list.vue?vue&type=script&setup=true&lang=ts&generic=Item%20extends%20SelectItem%2C%20Multiple%20extends%20boolean%20%3D%20false"
export * from "./base-select-list.vue?vue&type=script&setup=true&lang=ts&generic=Item%20extends%20SelectItem%2C%20Multiple%20extends%20boolean%20%3D%20false"
/* custom blocks */
import block0 from "./base-select-list.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__